<template>
  <div>
    <div class="h1">
      <div class="main">
        <img class="logo" src="../../assets/img/pagess/gdd110/222.png" alt="">
        <h5>更精确！更好用！更实战！</h5>
        <div @click="to_xaizai()" class="btn"></div>
      </div>
    </div>
    <div class="h2">
      <div class="main">
        <img class="img1" src="../../assets/img/pagess/gdd110/pic1.png" alt="">
        <img class="img2" src="../../assets/img/pagess/gdd110/pic2.png" alt="">
      </div>
    </div>
    <div class="h3">
      <div class="main">
        <img class="img3" src="../../assets/img/pagess/gdd110/pic3.png" alt="">
        <img class="img4" src="../../assets/img/pagess/gdd110/pic3.png" alt="">
        <img class="ico1" src="../../assets/img/pagess/gdd110/ico1.png" alt="">
        <img class="ico2" src="../../assets/img/pagess/gdd110/ico2.png" alt="">
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <el-carousel class="card" :interval="4000" type="card" height="500px">
          <el-carousel-item>
            <img src="../../assets/img/pagess/gdd110/pic5.png" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/img/pagess/gdd110/pic6.png" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/img/pagess/gdd110/pic7.png" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="h5">
      <div class="boxx"></div>
      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp; 合法机构名单可到中国证监会网站 (<a
          href="http://www.csrc.gov.cn/">www.csrc.gov.cn</a>)查询
      </p>
      <p>北京天相财富管理顾问有限公司河北分公司 &nbsp;&nbsp;&nbsp; <a
          href="https://beian.miit.gov.cn/">冀ICP备2021023389号-1</a>&nbsp;&nbsp;&nbsp;
        执证编号：91110102MA001GJE1N</p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>
      <p style=" 
    text-decoration: underline;cursor:pointer;" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <span @click="open_yinsi()" style="margin-right:10px">隐私保护政策</span>
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <div class="bar">
      <div class="main">
        <div @click="to_xaizai()" class="btn"></div>
      </div>
    </div>
    <div class="box"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false,
      message: "",
      btns: [
        {
          text1: "看大盘",
          text2: "一键知指数趋势",
        },
        {
          text1: "抓热点",
          text2: "秒速捕获异动板块",
        },
        {
          text1: "定策略",
          text2: "一键选股:多种选股思路",
        },
        {
          text1: "跟游资",
          text2: "量化龙虎榜行为数据",
        },
        {
          text1: "牛人圈",
          text2: "学龙头实战技巧",
        },
      ],
      imgs: [
        {
          icon: "1.png",
          name: "1111111",
        },
        {
          icon: "2.png",
          name: "22222",
        },
        {
          icon: "3.png",
          name: "22222",
        },
        {
          icon: "4.png",
          name: "22222",
        },
        {
          icon: "5.png",
          name: "22222",
        },
      ],
      active: 0,
    };
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScrollx, true);

    this.clientIp();
  },
  methods: {
    // open_yinsi() {
    //   window.open("https://ins.juniubang.com/images/隐私政策（河北）4.7.pdf");
    // },
    // open_fuwuxieyi() {
    //   window.open(
    //     "https://ins.juniubang.com/images/%E5%BA%94%E7%94%A8%E6%9D%83%E9%99%904.7(%E6%B2%B3%E5%8C%97).pdf"
    //   );
    // },
        open_yinsi() {
      window.open("https://ins.juniubang.com/images/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://ins.juniubang.com/images/应用权限4.7.pdf");
    },
    changebar(index) {
      this.active = index;
    },
    to_xaizai() {
      // window.open("https://cdn.juniubang.com/apk/GDD2003.exe");
      window.open("https://cdn.juniubang.com/apk/GDD1001.exe");

      this.post_leilei_data();
      this.message = "";
      // this.post_data();
    },
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          url: window.location.href,
          qhclickid: this.$route.query.bd_vid,
          code: this.$route.query.code,
          type: "baidu1",
        })
        .then((res) => {
           
        });
    },

    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 890) {
        this.res = true;
      } else {
        this.res = false;
      }
  
    },
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },
    // post_data() {
    //   this.$http
    //     .post("/to_api", {
    //       qhclickid: this.$route.query.qhclickid,
    //       trans_id: this.$route.query.qhclickid,
    //     })
    //     .then((res) => {
    //        
    //     });
    // },
  },
};
</script>
<style lang="less" scoped>
.h1 {
  width: 100%;
  height: 561px;
  background: url(../../assets/img/pagess/gdd110/index_01.png) no-repeat center;

  .logo {
    position: absolute;
    top: 15px;
    left: -400px;
  }
  h5 {
    position: absolute;
    top: 10px;
    left: 200px;
    width: 280px;
    font-size: 18px;
    color: #fff;
  }
  .main {
    width: 100px;
    margin: 0 auto;
    position: relative;
  }
  .btn {
    background: url(../../assets/img/pagess/gdd110/btn1.png);
    width: 234px;
    height: 60px;
    position: absolute;
    left: -297px;
    top: 354px;
  }
}
.h2 {
  background: url(../../assets/img/pagess/gdd110/index_02.png) center top
    no-repeat;
  height: 792px;
  .main {
    width: 100px;
    margin: 0 auto;
    position: relative;
    .img1 {
      position: absolute;
      left: -385px;
      top: 230px;
    }
    .img2 {
      position: absolute;
      left: 108px;
      top: 230px;
    }
  }
}
.h3 {
  background: url(../../assets/img/pagess/gdd110/index_03.png) center top
    no-repeat;
  height: 855px;
  .main {
    width: 100px;
    margin: 0 auto;
    position: relative;
    .img3 {
      position: absolute;
      left: -432px;
      top: 186px;
      visibility: visible;
      animation-duration: 1000ms;
      animation-name: fadeInRight;
    }
    .img4 {
      visibility: visible;
      animation-duration: 1000ms;
      animation-name: fadeInRight;
      position: absolute;
      left: -432px;
      top: 512px;
    }
    .ico1 {
      position: absolute;
      left: 26px;
      top: 236px;
      visibility: visible;
      animation-duration: 1000ms;
      animation-name: fadeInLeft;
    }
    .ico2 {
      position: absolute;
      left: 34px;
      top: 656px;
      visibility: visible;
      animation-duration: 1000ms;
      animation-name: fadeInLeft;
    }
  }
}
.h4 {
  background: url(../../assets/img/pagess/gdd110/index_04.png) center top
    no-repeat;
  height: 881px;
  padding-top: 50px;
  .w {
    width: 1200px;
    margin: 0 auto;
    padding-top: 180px;
  }
  .el-carousel__item img {
    width: 579px;
    height: 486px;
  }
}
.h5 {
  width: 100%;
  height: 150px;
  background-color: #021754;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: #fff;
  }
  a {
    font-size: 12px;
    color: #fff;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #6e7a9e;
  }
}
.box {
  width: 100%;
  height: 110px;
  background-color: #021754;
}
.bar {
  background: url(../../assets/img/pagess/gdd110/index_05.png) center top
    no-repeat;
  height: 99px;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9;
  .main {
    width: 100px;
    margin: 0 auto;
    position: relative;
    .btn {
      background: url(../../assets/img/pagess/gdd110/btn2.png);
      width: 299px;
      height: 61px;
      position: absolute;
      left: 224px;
      top: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/pagess/gdd110.vue